module.exports = __webpack_public_path__ + "img/img_inner_littleflower.584d332f.png";